import {
    ADMINGETBANKNAMELIST_SUCCESS,
    ADMINGETBANKNAMELIST_FAILED,
    RESET_ADMINGETBANKNAMELIST,
    LOADING_ADMINGETBANKNAMELIST,
    NETWORK_ERROR_ADMINGETBANKNAMELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETBANKNAMELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETBANKNAMELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETBANKNAMELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETBANKNAMELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETBANKNAMELIST:
            return (state = initialState);
        default:
            return state;
    }
};